<template>
  <div class="bq-page" ref="homePage">
    <div class="bq-coo-input">
      <span @click="goBack" class="bq-coo-back">返回</span>
      <div class="bq-coo-title" v-loading="loading">
        <header>请留下您的信息，我们将与您联系</header>
        <!-- <p>
          联系邮箱：<a
            class="bq-coo-mail"
            href="mailto:allen.lm@alibaba-inc.com"
            target="_blank"
            >allen.lm@alibaba-inc.com</a
          >
        </p> -->
        <el-form ref="form" :model="form">
          <el-form-item>
            <el-input
              v-model="form.name"
              placeholder="必填"
              class="inline-input pr20"
            >
              <template slot="prepend"
                >姓<span :style="{ padding: '0 16px' }"></span>名</template
              >
            </el-input>
            <el-input
              v-model="form.tel"
              placeholder="必填"
              class="inline-input pl20"
            >
              <template slot="prepend">联系电话</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.compname"
              placeholder="必填"
              class="inline-input pr20"
            >
              <template slot="prepend">企业名称</template>
            </el-input>
            <el-input
              v-model="form.title"
              placeholder="请输入职位"
              class="inline-input pl20"
            >
              <template slot="prepend"
                >职<span :style="{ padding: '0 16px' }"></span>位</template
              >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.email"
              placeholder="请输入邮箱"
              class="inline-input pr20"
            >
              <template slot="prepend"
                >邮<span :style="{ padding: '0 16px' }"></span>箱</template
              >
            </el-input>
            <el-input
              v-model="form.address"
              placeholder="请输入公司地址"
              class="inline-input pl20"
            >
              <template slot="prepend">公司地址</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="textarea-label">公司简介</div>
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.desc"
              placeholder="请输入公司简介"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="textarea-label">场地空间需求</div>
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.area"
              placeholder="请输入场地空间需求"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="textarea-label">其他孵化需求</div>
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.other"
              placeholder="请输入其他孵化需求"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bq-setin-input"></div>
  </div>
</template>
<script>
import { encryptByAES, checkPhoneNumber } from '@/utils/utils';

export default {
  name: 'cooperation',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        tel: '',
        compname: '',
        title: '',
        email: '',
        address: '',
        desc: '',
        area: '',
        other: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        compname: [
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    //离开时
    this.$parent.$refs['appHeader'].$refs.header.style.display = 'block';
    this.$parent.$refs['appFooter'].$refs.footer.style.display = 'block';
    next();
  },
  mounted() {
    this.$parent.$refs['appHeader'].$refs.header.style.display = 'none';
    this.$parent.$refs['appFooter'].$refs.footer.style.display = 'none';
    const clientHeight = document.documentElement.clientHeight;
    this.$refs.homePage.style.height = clientHeight + 'px';
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      console.log(this.form);

      if (!this.form.name) {
        this.$message({
          type: 'error',
          message: '请输入姓名',
        });
      } else if (!this.form.tel) {
        this.$message({
          type: 'error',
          message: '请输入联系电话',
        });
      } else if (!this.form.compname) {
        this.$message({
          type: 'error',
          message: '请输入企业名称',
        });
      } else if (!checkPhoneNumber(this.form.tel)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号或者电话号码',
        });
      } else {
        this.loading = true;
        this.$axios({
          method: 'post',
          url: 'https://jdapp.bechangedt.com/hospitalapi/mail/send',
          data: {
            title: '孵化器入驻咨询',
            sendMailNo: 'alihuxuejun@aliyun.com', //发送者邮箱
            receiveMailNo: 'allen.lm@alibaba-inc.com', //接收者邮箱
            authCode: 'nwikpnzkeahhecdh', //发送者授权码
            name: this.form.name,
            telPhone: this.form.tel,
            enterpriseName: this.form.compname, //企业名称
            email: this.form.email,
            position: this.form.title, //职位
            enterpriseAddress: this.form.address, // 公司地址
            introduce: this.form.desc, // 公司介绍
            siteRequirements: this.form.area, // 空间需求
            otherRequirements: this.form.other, // 其他需求
          },
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [
            function(data) {
              // 对 data 进行任意转换处理
              return JSON.stringify({
                content: encryptByAES(JSON.stringify(data), 'GH$2RY28XNQ39A8X'),
              });
            },
          ],
        }).then(response => {
          this.loading = false;
          console.log(response);
          if (response.status >= 200 && response.status < 300) {
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '已提交',
              });
              this.$router.back();
              // console.log('成功'); // 请求成功，response为成功信息参数
            } else {
              this.$message({
                type: 'error',
                message: '提交失败',
              });
            }
          } else {
            this.$message({
              type: 'error',
              message: '提交失败',
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../assets/styles/fn.less';

.bq-page {
  width: 100%;
  background-image: url('https://img.alicdn.com/tfs/TB1Ac0zC.Y1gK0jSZFCXXcwqXXa-1920-1382.png');
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .bq-coo-input {
    width: 80%;
    height: 55%;
    min-height: 730px;
    padding: 75px 114px;
    border-radius: 8px;
    opacity: 0.95;
    background-color: #fff;
    text-align: center;
    position: relative;

    .bq-coo-back {
      display: inline-block;
      margin-left: 0;
      position: absolute;
      left: 20px;
      top: 20px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .inline-input {
      width: 50%;
    }

    /deep/ .el-form {
      margin-top: 50px;
      .el-form-item {
        margin-bottom: 30px;
      }
      .el-form-item__content {
        display: flex;
        color: #333333;

        .el-button {
          width: 170px;
          height: 50px;
          background-color: #0d3091;
          border-radius: 31px;
          color: #ffffff;
          font-size: 18px;
          display: block;
          margin: 0 auto;
          span {
            width: 66px;
            display: inline-block;
            text-align: center;
            letter-spacing: 30px;
          }
        }

        .el-input-group__prepend {
          min-width: 104px;
          background-color: transparent;
        }

        .el-textarea__inner {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        .textarea-label {
          color: #909399;
          position: relative;
          // top: -10px;
          border: 1px solid #dcdfe6;
          border-right: 0;
          border-radius: 4px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: 0;
          min-width: 104px;
          white-space: nowrap;
          line-height: 52px;
        }

        .pl20 {
          padding-left: 20px;
        }

        .pr20 {
          padding-right: 20px;
        }
      }
    }

    .bq-coo-title {
      margin-bottom: 60px;
      header {
        color: #333333;
        font-size: 24px;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
      }
    }

    .bq-coo-mail {
      border-radius: 8px;
      color: @themeColor;
      font-size: 16px;
    }
  }
}
</style>
